import { render, staticRenderFns } from "./DistributionType.vue?vue&type=template&id=677a9204&scoped=true&"
import script from "./DistributionType.vue?vue&type=script&lang=js&"
export * from "./DistributionType.vue?vue&type=script&lang=js&"
import style0 from "./DistributionType.vue?vue&type=style&index=0&id=677a9204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a9204",
  null
  
)

export default component.exports